import React, { PureComponent } from 'react';
import { Button } from '..';

import styles from './styles';

export default class ScrollWindow extends PureComponent {

  constructor (props) {
    super(props)

    this.currentScrollY = 0;
    this.scrollTicking = false;
    this.resizeTicking = false;
    this.state = {
      height: null,
      top: null,
      isVisible: false
    };
  }

  getScrollY = () => {

    if (window.pageYOffset !== undefined) {
      return window.pageYOffset;
    } else if (window.scrollTop !== undefined) {
      return window.scrollTop;
    }

    return (document.documentElement || document.body.parentNode || document.body).scrollTop;
  };

  getScrollerPhysicalHeight = () => (
    window.innerHeight
      || document.documentElement.clientHeight
      || document.body.clientHeight
  );

  isOutOfBounds = (currentScrollY) => {
    const { height, top } = this.state;
    const scrollerPhysicalHeight = this.getScrollerPhysicalHeight();
    const bottomOfElementIsVisible = currentScrollY + scrollerPhysicalHeight > top + height;
    const topOfElementIsVisible = currentScrollY < top;

    return bottomOfElementIsVisible || topOfElementIsVisible;
  };

  update = () => {
    this.currentScrollY = this.getScrollY();

    // Determine if the current scroll position is outside the bounds of the container
    const isOutOfBounds = this.isOutOfBounds(this.currentScrollY);

    // Hide the button if it should not be shown
    if (isOutOfBounds && this.state.isVisible) {
      this.setState({
        isVisible: false
      });
    }

    // Show the button if it should be shown
    if (!isOutOfBounds && !this.state.isVisible) {
      this.setState({
        isVisible: true
      });
    }

    this.scrollTicking = false;
  };

  setHeightOffset = () => {
    this.setState({
      height: this.container.offsetHeight,
      top: this.container.offsetTop
    });
    this.resizeTicking = false;
  };

  handleScroll = () => {
    if (!this.scrollTicking) {
      this.scrollTicking = true;
      window.requestAnimationFrame(this.update);
    }
  };

  handleResize = () => {
    if (!this.resizeTicking) {
      this.resizeTicking = true;
      window.requestAnimationFrame(this.setHeightOffset);
    }
  };

  componentDidMount() {
    this.setHeightOffset();

    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleResize);
  }

  componentDidUpdate(prevProps) {

    // If children have changed, remeasure height.
    if (prevProps.children !== this.props.children) {
      this.setHeightOffset();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
  }

  renderButton() {
    const { label, onClick } = this.props;
    const { isVisible } = this.state;
    const classes = [ styles.scrollWindowButton, 'main-button' ];

    if (isVisible) {
      classes.push(styles.scrollWindowButtonVisible);
    }

    return (
      <Button
        className={ classes.join(' ') }
        onClick={ onClick }
      >
        { label }
      </Button>
    );
  }

  render() {
    const { children } = this.props;

    return (
      <div
        className={ styles.scrollWindow }
        ref={ (ref) => {
          this.container = ref;
        } }
      >
        { children }
        { this.renderButton() }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ScrollWindow/index.jsx